import { render, staticRenderFns } from "./cs.vue?vue&type=template&id=2fba6e64&scoped=true&"
import script from "./cs.vue?vue&type=script&lang=js&"
export * from "./cs.vue?vue&type=script&lang=js&"
import style1 from "./cs.vue?vue&type=style&index=1&id=2fba6e64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba6e64",
  null
  
)

export default component.exports